var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSpray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 19.8751H17.0625V26.0001H11.9375V19.8751Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.9377H9C7.38025 13.9377 6.0625 15.2555 6.0625 16.8752V29.0626C6.0625 30.6823 7.38025 32.0001 9 32.0001H20C21.6198 32.0001 22.9375 30.6823 22.9375 29.0626V16.8752C22.9375 15.2555 21.6198 13.9377 20 13.9377ZM18.9375 26.9377C18.9375 27.4554 18.5177 27.8752 18 27.8752H11C10.4823 27.8752 10.0625 27.4554 10.0625 26.9377V18.9377C10.0625 18.4199 10.4823 18.0002 11 18.0002H18C18.5177 18.0002 18.9375 18.4199 18.9375 18.9377V26.9377Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 4.0625H23.5C22.9822 4.0625 22.5625 4.48225 22.5625 5C22.5625 5.51775 22.9822 5.9375 23.5 5.9375H25C25.5177 5.9375 25.9375 5.51775 25.9375 5C25.9375 4.48225 25.5177 4.0625 25 4.0625Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1827 2.64253L23.1827 1.58003C23.5376 1.20303 23.5196 0.609716 23.1425 0.254841C22.7655 -0.100097 22.1721 -0.0820343 21.8173 0.295028L20.8173 1.35753C20.4624 1.73453 20.4804 2.32784 20.8575 2.68272C21.2343 3.03759 21.8278 3.01959 22.1827 2.64253Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1629 6.83709C21.7968 6.47097 21.2032 6.47097 20.8371 6.83709C20.4709 7.20322 20.4709 7.79678 20.8371 8.16291L21.8371 9.16291C22.2032 9.52903 22.7967 9.52903 23.1629 9.16291C23.529 8.79684 23.529 8.20328 23.1629 7.83709L22.1629 6.83709Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4375 10.7501C19.4375 10.2324 19.0177 9.81262 18.5 9.81262H10.5C9.98225 9.81262 9.5625 10.2324 9.5625 10.7501V12.0627H19.4375V10.7501Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 5.9375H16.4376C15.9198 5.9375 15.5001 5.51775 15.5001 5C15.5001 4.48225 15.9198 4.0625 16.4376 4.0625H17.9375V2C17.9375 1.48225 17.5177 1.0625 17 1.0625H12C11.4822 1.0625 11.0625 1.48225 11.0625 2V7.93762H17.9375V5.9375Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpray);
export default __webpack_public_path__ + "static/media/ic-spray.8d7f82b3722f0ded8c132c84a68a0dc2.svg";
export { ForwardRef as ReactComponent };